// extracted by css-extract-rspack-plugin
export default {"first":"pGz0ex","second":"MT0vc9","third":"p13UYb"};